<div>
    <div style="margin-left: 70%; margin-bottom: 2%">
        <!-- <button class="btn btn-info" mat-raised-button (click)="assigndisrep()">
            Add Distribution Rep.
        </button> -->
        <!-- <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printSectionId="print-section" ngxPrint>
            print
        </button> -->
        <button class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
            printSectionId="print-section" ngxPrint [useExistingCss]="true">
            print
        </button>
        <button mat-dialog-close class="btn noPrint">Close</button>
    </div>
    <div class="container" id="print-section">
        <div style="margin: 0px 15px;">
            <div class="row text-center">
                <div class="col-3">
                    <img src="../../../assets/img/brand/red.png" alt="logo" width="100" height="100">
                </div>
                <div class="col-5 text-center mt-1">
                    <span style="font-size: 18px; font-weight: bold;">
                        हिंदुस्थान प्रकाशन संस्था, विवेक साप्तहिक<br>
                        ११६, ११७, ११८, ११९, पहिला मजला, शिल्पीन सेंटर,<br>
                        ग. द. आंबेकर मार्ग, वडाला, मुंबई - ४०००३१
                    </span>

                </div>
                <div class="col-4" style="font-weight: bold;">
                    <div class="text-end" style="font-size: 14px;">दिनांक:
                        {{ currentDate | date:'dd-MM-yyyy' }}
                    </div>
                    <div class="text-end" style="font-size: 14px;">&nbsp;From:
                        {{ start_date | date:'dd-MM-yyyy' }}
                    </div>
                    <div class="text-end" style="font-size: 14px;">&nbsp;To:
                        {{ end_date | date:'dd-MM-yyyy' }}
                    </div>

                </div>

            </div>
            <div class=" text-center">
                <div class="text-end" style="font-size: 18px;padding-bottom: 20px; font-weight: bold;">प्रतिनिधी नाव:
                    {{ rep_name }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 col-md-6 col-lg-6 col-xl-6"
                    style="border-right: 2px solid #000;border-top: 2px solid #000;border-bottom: 2px solid #000;">
                    <p class="cr-dr">Cr</p>
                    <div style="display: flex; justify-content: space-between; font-weight: bold;">
                        <span class="text" style="width: 30%;">वो. क्रमांक <span class="text"
                                style="width: 25%;"><br>दिनांक</span></span>
                        <span class="text" style="width: 60%;">खर्च खाते व तपशील</span>
                        <span class="text" style="width: 10%;">जमा रक्कम</span> <br>
                    </div>
                </div>
                <div class="col-6 col-md-6 col-lg-6 col-xl-6"
                    style="border-top: 2px solid #000;border-bottom: 2px solid #000; font-weight: bold;">
                    <p class="cr-dr">Dr</p>
                    <div style="display: flex; justify-content: space-between; padding-bottom: 10px;">
                        <span class="text" style="width: 30%;">वो. क्रमांक <span class="text"
                                style="width: 25%;"><br>दिनांक</span></span>
                        <span class="text" style="width: 60%;">खर्च खाते व तपशील</span>
                        <span class="text" style="width: 10%;">जमा रक्कम</span> <br>
                    </div>
                </div>
            </div>

            <div class="row" *ngFor="let item of pairedData">
                <!-- CR Column -->
                <div class="col-6" style="border-right: 2px solid #000;">
                    <div *ngIf="item.cr">
                        <hr />
                        <div *ngFor="let detail of item.cr.voucherDetails; let i = index"
                            style="display: flex; justify-content: space-between;">
                            <span class="text" style="width: 30%; font-weight: bold;" *ngIf="i === 0">
                                {{ item.cr.voucher_no }}<br />{{ item.cr.voucher_date | date: 'dd-MM-yyyy' }}
                            </span>
                            <span class="text" style="width: 30%;" *ngIf="i !== 0"></span>
                            <span class="text" style="width: 60%; font-weight: bold;">{{ detail.department_type
                                }}</span>
                            <span class="text" style="width: 10%; font-weight: bold;">{{ detail.voucher_amt }}</span>
                        </div>
                    </div>
                </div>

                <!-- DR Column -->
                <div class="col-6">
                    <div *ngIf="item.dr">
                        <hr />
                        <div *ngFor="let detail of item.dr.voucherDetails; let i = index"
                            style="display: flex; justify-content: space-between;">
                            <span class="text" style="width: 30%; font-weight: bold;" *ngIf="i === 0">
                                {{ item.dr.voucher_no }}<br />{{ item.dr.voucher_date | date: 'dd-MM-yyyy' }}
                            </span>
                            <span class="text" style="width: 30%;" *ngIf="i !== 0"></span>
                            <span class="text" style="width: 60%; font-weight: bold;">{{ detail.department_type
                                }}</span>
                            <span class="text" style="width: 10%; font-weight: bold;">{{ detail.voucher_amt }}</span>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>